import { Event } from "../../../Global/Base/Events";
import { IToolbarButton } from "../../UI/UI/XGControls/Actions/IToolbarButton";
import { ActionContext, ActionType, IAction, IBaseAction, SelectionType } from "./IAction";
import { MenuType } from "./MenuType";

export class Action implements IAction {
    public actionSize: string;

    public parentAction: IAction;
    private _enabled: boolean = true;
    private _enabledVisual: boolean = true;
    private _visible: boolean = true;
    private _actionType: ActionType = ActionType.none;

    public priority: number;
    public order: number;
    public locKey: string;
    public locParams: string[];
    public action: () => Promise<void> = async () => { /* Prázdná arrow funkce */ };

    //volitelné property
    public toMenu?: MenuType;
    public toolbarButton?: IToolbarButton; //TODO: [WI 16310] Refaktoring DesktopToolbarButton
    public menuType?: MenuType;
    public masterNode?: string;
    public isInNode: boolean = false;

    //události
    public readonly enabledChanged: Event<IBaseAction, boolean> = new Event<IBaseAction, boolean>();
    public readonly visibilityChanged: Event<IBaseAction, boolean> = new Event<IBaseAction, boolean>();
    public readonly enabledVisualChanged: Event<IBaseAction, boolean> = new Event<IBaseAction, boolean>();
    public readonly isActiveChanged: Event<IBaseAction, boolean> = new Event<IBaseAction, boolean>();
    public readonly interactiveChanged: Event<IBaseAction, boolean> = new Event<IBaseAction, boolean>();

    public get enabled(): boolean {
        return this._enabled;
    }

    public set enabled(v: boolean) {
        this._enabled = v;
        this.enabledChanged.trigger(this, v); // TODO-rites
        this.isActiveChanged.trigger(this, v); // dědící třída by měla toto notifikovat při změně příznaku isActive  // TODO-rites
    }

    public get enabledVisual(): boolean {
        return this._enabledVisual;
    }

    public set enabledVisual(value: boolean) {
        const oldValue = this._enabledVisual;

        this._enabledVisual = value;

        if (value !== oldValue)
            this.enabledVisualChanged.trigger(this, value);
    }

    /**
     * Pokud bude dědící třída implementovat IReadOnlyControl, měla by být property přepsaná tak,
     * aby reflektovala i příznak isReadOnly
     */
    public get isActive(): boolean {
        return this.enabled;
    }

    public get visible(): boolean {
        return this._visible;
    }

    public set visible(v: boolean) {
        this._visible = v;
        this.visibilityChanged.trigger(this, v);
    }

    public async execute(): Promise<void> {
        if (this.isActive && this.action)
            this.action();
    }

    public get context(): ActionContext {
        return ActionContext.none;
    }

    public get actionType(): ActionType {
        return this._actionType;
    }

    public set actionType(type: ActionType) {
        this._actionType = type;
    }

    public get supportedSelectionModes(): SelectionType {
        return SelectionType.single;
    }

    constructor(action?: (...params: any[]) => Promise<void>, locKey?: string, locParams?: string[]) {
        this.action = action || (async () => { /* Prázdná arrow funkce */ });
        this.locKey = locKey;
        this.locParams = locParams;
    }

    public dispose(): void {
        // Prázdná metoda
    }
}
